import NameDpo from './NameDpo'

export default { NameDpo }
